import type { PaymentSearchResult } from '@app/api/ClientPayments';
import { divideAmount } from '@app/utils/divideAmount';

export const formatPaymentTotalAmount = (
  amount: PaymentSearchResult['TotalAmount']
): string => {
  if (amount == null) return '—';
  if (typeof amount === 'number' && !Number.isFinite(amount)) return '—';

  const decimal =
    typeof amount === 'number'
      ? amount.toLocaleString('en-US', {
          useGrouping: false,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : amount.toFixed(2);

  return /^-?\d+(\.\d+)?$/.test(decimal) ? divideAmount(decimal) : '—';
};
